import * as React from 'react'
import Modal from '../../ui/Modal'
import { IGoinZoneObject, IStationUserGoinZoneObject } from 'src/types'
import { Button, Popup } from '@mobiscroll/react-latest'
import UIMessages from 'src/utils/ui-messages'
import Divider from 'src/components/ui/Divider'

export interface IRemoveZoneModalProps {
  onClose: () => void
  onRemove: (zone: IStationUserGoinZoneObject) => Promise<any>
  zones: { [key: number]: IStationUserGoinZoneObject }
}

interface IRemoveZoneModalState {
  isPending?: boolean
  error?: string
  newOption?: string
  popupOpen: boolean
}

class RemoveZoneModal extends React.Component<any, IRemoveZoneModalState> {
  constructor(props: IRemoveZoneModalProps) {
    super(props)
    this.state = {
      popupOpen: true
    }
  }

  public render() {
    const zone: IStationUserGoinZoneObject = this.props.zones[this.props.match.params.id]
    const { cancel, deleteConfirmation, deleteLabel, zone: zoneLabel } = UIMessages.common
    return (
      <Popup isOpen={this.state.popupOpen} width={400} onClose={() => this.setState({ popupOpen: false })}>
        <div className='p2'>
          <p className='mt0 uppercase'>{`${deleteLabel} ${zoneLabel}`}</p>
          <Divider />

          <p>
            {deleteConfirmation}
            <strong>{` ${zone ? zone.name : ''}`}</strong>
            {`${zone ? ` from ${zone.zoneType}` : ''}`}?
          </p>

          <div className='flex justify-end mt2'>
            <Button ariaLabel='Cancel button' className='mbsc-flat-btn' onClick={this.handleCancelClick}>
              {cancel}
            </Button>
            <Button ariaLabel='Delete button' className='mbsc-danger-btn' onClick={this.handleRemoveClick}>
              {deleteLabel}
            </Button>
          </div>
        </div>
      </Popup>
    )
  }

  private handleRemoveClick = () => {
    this.props.onClose()
    const zone = this.props.zones[this.props.match.params.id]
    this.props.onRemove(zone)
  }

  private handleCancelClick = () => {
    this.props.onClose()
  }
}

export default RemoveZoneModal



// WEBPACK FOOTER //
// ./src/components/station-user/view/RemoveZoneModal.tsx